import React, { useEffect, useState } from "react";
import { Wallet } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar2 from "../components/navbar/Navbar2";
import { api, socket } from "../api"; // ✅ Use your shared API + socket
import { parseJWT } from "../utils/jwtUtils";

const ReferralIncome = () => {
  const [referrals, setReferrals] = useState([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();

    const fetchReferrals = async () => {
      try {
        const token = localStorage.getItem("userInfo")
          ? JSON.parse(localStorage.getItem("userInfo"))
          : null;
        const userInfo = parseJWT(token?.token);

        if (!userInfo?.referralCode) {
          setMessage("No referral code found for this user.");
          setLoading(false);
          return;
        }

        // ✅ Fetch referrals using shared API instance
        const { data } = await api.get(`/referrals/${userInfo.referralCode}`);
        // console.log("referral info : ", data);
        if (data.success) {
          setReferrals(data.referrals || []);
          setTotalIncome(data.totalIncome || 0);
          setMessage("");
        } else {
          setMessage(data.message || "Unable to load referral data.");
        }
      } catch (err) {
        console.error("⚠️ Failed to fetch referral history:", err);
        setMessage("Failed to load referral history. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, []);

  return (
    <>
      {/* Navbar */}
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900">
        <Navbar2 />
      </div>

      {/* Page background */}
      <div className="min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#020617] text-white pt-24 pb-10 px-4 flex justify-center">
        <div className="w-full max-w-5xl bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl shadow-xl p-3 md:p-6">
          {/* Title */}
          <div className="flex justify-center items-center gap-2 mb-6">
            <Wallet className="text-yellow-400 w-7 h-7" />
            <h1 className="text-2xl font-semibold text-yellow-400 font-serif">
              Referral Income
            </h1>
            <Wallet className="text-yellow-400 w-7 h-7" />
          </div>

          {/* Summary */}
          <div className="text-center mb-6 font-serif">
            {loading ? (
              <p className="text-gray-300">Loading referral data...</p>
            ) : message ? (
              <p className="text-red-400">{message}</p>
            ) : (
              <p className="text-lg text-green-400 font-semibold">
                💰 Total Referral Income: {totalIncome.toFixed(2)} ETB
              </p>
            )}
          </div>

          {/* Table */}
          <div className="overflow-x-auto rounded-xl border border-white/20">
            <table className="w-full text-sm text-center border-collapse">
              <thead>
                <tr className="bg-white/10 text-gray-200">
                  <th className="px-2 md:px-4 py-3 border border-white/10 font-serif">
                    No
                  </th>
                  <th className="px-2 md:px-4 py-3 border border-white/10 font-serif">
                    Phone
                  </th>
                  <th className="px-2 md:px-4 py-3 border border-white/10 font-serif">
                    Date
                  </th>
                  <th className="px-2 md:px-4 py-3 border border-white/10 font-serif">
                    Bonus
                  </th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="py-5 text-gray-300 bg-white/5 font-serif"
                    >
                      Loading...
                    </td>
                  </tr>
                ) : referrals.length === 0 ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="font-serif py-5 text-gray-300 bg-gradient-to-r from-white/10 to-white/5 rounded-b-xl"
                    >
                      No referral income
                    </td>
                  </tr>
                ) : (
                  referrals.map((user, index) => (
                    <tr
                      key={index}
                      className="hover:bg-white/10 transition-all duration-200"
                    >
                      <td className="px-4 py-3 border border-white/10 font-serif">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 border border-white/10 font-serif">
                        {user.phone}
                      </td>
                      <td className="px-4 py-3 border border-white/10 font-serif">
                        {new Date(user.registeredDate).toLocaleDateString()}
                      </td>
                      <td className="px-4 py-3 border border-white/10 text-green-400 font-semibold font-serif">
                        {user.income?.toFixed(2)} ETB
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferralIncome;
